import React, { useEffect, useState, useRef, useContext } from "react";
import { USERTYPES } from "../../../constants/Constants";
import { useTranslation } from "react-i18next";
import { Dropdown } from "@fluentui/react";
import {
  getSubModalityList,
  saveNewSubModality,
  editExistingSubModality,
  getModalityList,
} from "../../../service/MasterService";
import ColumnSubModality from "./ColumnSubModality";
import NewSubModality from "../SubModality/NewSubModality";
import EditSubModality from "./EditSubModality";
import ModalMain from "../../../components/Modal/ModalMain";
import ModalFooter from "../../../components/Modal/ModalFooter";
import ModalHeader from "../../../components/Modal/ModalHeader";
import userContext from "../../../context/users/UserContext";
import { PrimaryButton } from "@fluentui/react";
import loaderContext from "../../../context/loader/LoaderContext";
import ListViewV3 from "../../../components/ListViewV3/ListViewV3";
import toastContext from "../../../context/toast/ToastContext";
import { TOAST_TYPE } from "../../../constants/Constants";

const SubModality = () => {
  const [t] = useTranslation();
  const { roles, loadByUsername, authenticated } = useContext(userContext);
  const { showToastv2 } = useContext(toastContext);
  const [loading, setLoading] = useState(false);
  const { setLoaderRunning, ref } = useContext(loaderContext);
  const [paginationObj, setPagination] = useState({
    pageIndex: 0,
    pageSize: 30,
  });
  const [filterObj, setFilterObj] = useState({
    filterInput: null,
    filterUpdate: 0,
  });
  const [sortObj, setSortObj] = useState({
    sortFieldText: "",
    sortFieldValue: "",
    sortDir: false,
    selected: false,
  });
  const [serviceCode, setServiceCode] = useState("");
  const [serviceName, setServiceName] = useState("");
  const [modalityId, setModalityId] = useState("");
  const [expirationTime, setExpirationTime] = useState("");
  const [editServiceName, setEditServiceName] = useState("");
  const [editServiceCode, setEditServiceCode] = useState("");
  const [editModalityId, setEditModalityId] = useState("");
  const [editExpirationTime, setEditExpirationTime] = useState("");
  const [editSubModalityId, setEditSubModalityId] = useState(null);
  const [selectedListNumber, setSelectedListNumber] = useState(null);
  const [uniqueSubModalityNumbersList, setUniqueSubModalityNumbersList] =
    useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [modalityIdErrorMsg, setModalityIdErrorMsg] = useState("");
  const [serviceCodeErrorMsg, setServiceCodeErrorMsg] = useState("");
  const [serviceNameErrorMsg, setServiceNameErrorMsg] = useState("");
  const [expirationTimeErrorMsg, setExpirationTimeErrorMsg] = useState("");
  const [editExpirationTimeErrorMsg, setEditExpirationTimeErrorMsg] =
    useState("");
  const [editServiceNameErrorMsg, setEditServiceNameErrorMsg] = useState("");
  const [isError, setIsError] = useState(false);

  const [isSubModalitySaved, setIsSubModalitySaved] = useState(false);
  const [isSubModalityEdited, setIsSubModalityEdited] = useState(false);
  const [subModalityList, setSubModalityList] = useState([]);
  const [modalityList, setModalityList] = useState([]);
  const dropdownRef = useRef();

  //need this for pagination dto
  function camelToUnderscore(key) {
    var result = key.replace(/([A-Z])/g, " $1");
    return result.split(" ").join("_").toLowerCase();
  }

  useEffect(() => {
    if (!authenticated) {
      loadByUsername();
    }
    fetchModalityList();
  }, []);

  //fetching modality list only when the component loads, not every time
  const fetchModalityList = async () => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      const response = await getModalityList();
      if (response.status === 200 && response.data.result === "SUCCESS") {
        setLoaderRunning(false);
        ref.current.complete();
        setModalityList(response.data.data.modalityList);
      }
    } catch (e) {
      console.log("--- Error ----", e);
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  const fetchSubModalityList = async (options) => {
    let sortParams = "id";
    let sortyByDir = false;

    if (
      options.sortObj.sortFieldValue != undefined &&
      options.sortObj.sortFieldValue.length > 0
    ) {
      sortParams = options.sortObj.sortFieldValue;
      sortyByDir = options.sortObj.sortDir;
    }

    const body = {
      paginationDto: {
        pageNumber: options.page,
        pageSize: 30,
        sortField: camelToUnderscore(sortParams),
        sortOrder: sortyByDir,
        filterInput:
          options.filterObj.filterInput == null
            ? ""
            : options.filterObj.filterInput,
      },
      listNumber: selectedListNumber,
    };

    setLoaderRunning(true);
    ref.current.continuousStart();

    try {
      console.log("Getting subModalityList with payload: ", body);
      const response = await getSubModalityList(body);
      let data = null;
      let pageCount = null;
      if (response.status === 200 && response.data.result === "SUCCESS") {
        setLoaderRunning(false);
        ref.current.complete();
        data = response.data.data.subModalityList.content;
        pageCount = response.data.data.subModalityList.totalPages;
        setSubModalityList(response.data.data.subModalityList.content);
        setUniqueSubModalityNumbersList(
          response.data.data.uniqueSubModalityNumbersList
        );
        return {
          rows: data,
          pageCount: pageCount,
        };
      } else {
        setLoaderRunning(false);
        ref.current.complete();
        return {
          rows: data,
          pageCount: pageCount,
        };
      }
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const handleClickGroup = async (event, data, cell) => {
    // event.stopPropagation();
    // let response;
    // try {
    //   // if (roles[0] === USERTYPES.ADMIN) {
    //   //   response = await changeFirmStatus(cell.row.original.id);
    //   // }
    //   if (response.status === 200 && response.data.result === "SUCCESS") {
    //     ReloadData(data);
    //   }
    // } catch (e) {
    //   console.log(e);
    // }
  };

  useEffect(() => {
    setServiceCode("");
    setServiceName("");
    setModalityId("");
    setExpirationTime("");
    setModalityIdErrorMsg("");
    setServiceNameErrorMsg("");
    setServiceCodeErrorMsg("");
    setExpirationTimeErrorMsg("");
  }, [isModalOpen]);

  useEffect(() => {
    setEditExpirationTimeErrorMsg("");
    setEditServiceNameErrorMsg("");
  }, [isEditModalOpen]);

  useEffect(() => {
    console.log("EditServiceName in SubModality : ", editServiceName);
  }, [editServiceName]);

  const saveSubModality = async () => {
    if (modalityId.length == 0) {
      setModalityIdErrorMsg("Select a Modality");
      setIsError(true);
    }
    if (serviceCode.length == 0) {
      setServiceCodeErrorMsg("Service code cannot be empty");
      setIsError(true);
    }
    if (serviceName.length == 0) {
      setServiceNameErrorMsg("Service name cannot be empty");
      setIsError(true);
    } else {
      setModalityIdErrorMsg("");
      setServiceCodeErrorMsg("");
      setServiceNameErrorMsg("");
      setIsError(false);
    }

    if (isError) return;
    setLoading(true);
    console.log(
      "uniqueSubModalityNumbersList[0] --> ",
      uniqueSubModalityNumbersList[0]
    );
    const saveSubModalityDto = {
      modalityId: modalityId,
      serviceCode: serviceCode,
      serviceName: serviceName,
      expirationTime: expirationTime,
      listNumber:
        selectedListNumber == null || selectedListNumber == ""
          ? uniqueSubModalityNumbersList[0]
          : selectedListNumber,
    };
    try {
      setLoaderRunning(true);
      ref.current.continuousStart();
      const response = await saveNewSubModality(saveSubModalityDto);
      console.log("response", response);
      console.log(
        "response.status, response.data.result",
        response.status,
        response.data.result
      );
      if (response.status === 200 && response.data.result === "SUCCESS") {
        setIsSubModalitySaved(true);
        setLoaderRunning(false);
        setModalOpen(false);
        ref.current.complete();
        showToastv2("success", response.data.message);
        setPagination((prevPagination) => ({
          ...prevPagination,
          pageIndex: 0,
          row: null,
        }));
        setFilterObj(() => {
          const newItem = { ...filterObj };
          newItem.filterUpdate = newItem.filterUpdate + 1;
          return newItem;
        });
      } else if (response.data.result === "FAILURE") {
        showToastv2(TOAST_TYPE.ERROR, response.data.message);
        const errors = response.data.data.errors;
        if (errors.length > 0) {
          errors.forEach((error) => {
            console.log("error: ", error);
            switch (error.fieldName) {
              case "modalityId":
                setModalityIdErrorMsg(error.defaultMessage);
                break;
              case "serviceCode":
                setServiceCodeErrorMsg(error.defaultMessage);
                break;
              case "serviceName":
                setServiceNameErrorMsg(error.defaultMessage);
                break;
              case "expirationTime":
                setExpirationTimeErrorMsg(error.defaultMessage);
                break;
              default:
                break;
            }
          });
        }
        console.log("Error -----", response.data.message);
        setLoaderRunning(false);
        ref.current.complete();
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  const handleUserClick = async (cell) => {
    // cell = cell.row.original;
    // if (roles[0] != USERTYPES.RADIOLOGIST) {
    //   navigate(AuthRoutes.FIRMDETAILS + "?firmId=" + cell.id + "&type=" + 0
    //   // , {
    //     // state: {
    //     //   firmId: cell.id,
    //     //   type: 0,
    //     //   hospital: false,
    //     //   action: ACTIONS.VIEW,
    //     // },
    //   // });
    //   )
    // }
  };

  const handleEdit = (cellData) => {
    setIsEditModalOpen(true);
    setIsSubModalityEdited(false);
    setEditServiceName(cellData.serviceName);
    setEditServiceCode(cellData.serviceCode);
    setEditExpirationTime(cellData.expirationTime);
    setEditSubModalityId(cellData.id);
    console.log("EditCellData ---->", cellData);
  };

  const editSubModality = async (event) => {
    event.stopPropagation();
    console.log("Edit SubModality was clicked");

    setLoading(true);
    const editSubModalityDto = {
      serviceName: editServiceName,
      expirationTime: editExpirationTime,
      id: editSubModalityId,
    };
    try {
      setLoaderRunning(true);
      ref.current.continuousStart();
      const response = await editExistingSubModality(editSubModalityDto);

      if (response.status === 200 && response.data.result === "SUCCESS") {
        setEditModalityId("");
        setEditServiceName("");
        setEditExpirationTime("");
        setEditSubModalityId("");
        setIsSubModalityEdited(true);
        setLoaderRunning(false);
        setIsEditModalOpen(false);
        ref.current.complete();
        showToastv2("success", response.data.message);
        setFilterObj(() => {
          const newItem = { ...filterObj };
          newItem.filterUpdate = newItem.filterUpdate + 1;
          return newItem;
        });
      } else if (response.data.result === "FAILURE") {
        showToastv2(TOAST_TYPE.ERROR, response.data.message);
        const errors = response.data.data.errors;
        if (errors.length > 0) {
          errors.forEach((error) => {
            console.log("error: ", error);
            switch (error.fieldName) {
              case "expirationTime":
                setEditExpirationTimeErrorMsg(error.defaultMessage);
                break;
              case "serviceName":
                setEditServiceNameErrorMsg(error.defaultMessage);
                break;
              default:
                break;
            }
          });
        }
        console.log("Error -----", response.data.message);
        setLoaderRunning(false);
        ref.current.complete();
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  const columns = ColumnSubModality(handleClickGroup, roles[0], handleEdit);

  const options = [
    { key: "serviceCode", text: "Service Code" },
    { key: "serviceName", text: "Service Name" },
    { key: "modalityName", text: "Modality" },
  ];

  const listNumberOptionsFunction = () => {
    let options = [];
    uniqueSubModalityNumbersList.map((listNumber) => {
      options.push({ key: listNumber, text: listNumber });
    });
    return options;
  };

  const dropdownStyles = {
    dropdown: { width: 150, broderRadius: 0 },
    dropdownItemsWrapper: {
      maxHeight: "400px",
    },
    title: {
      borderRadius: "7px",
      background: "none",
      height: "32px",
      display: "flex",
      alignItem: "center",
    },
    dropdownItems: {
      selectors: {
        "@media(min-width: 640px)": {
          maxHeight: 300,
        },
      },
    },
  };

  const handleListNumberChange = (option) => {
    setSelectedListNumber(option);
    setPagination((prevPagination) => ({
      ...prevPagination,
      pageIndex: 0,
      row: null,
    }));
    setFilterObj(() => {
      const newItem = { ...filterObj };
      newItem.filterUpdate = newItem.filterUpdate + 1;
      return newItem;
    });
  };

  const buttonsTopBar = [
    roles[0] === USERTYPES.ADMIN && {
      key: "1",
      button: (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginRight: "10px",
          }}
        >
          <p className="sort-search-text">Sub Modality List</p>
          <Dropdown
            componentRef={dropdownRef}
            options={listNumberOptionsFunction()}
            value={selectedListNumber}
            placeholder={uniqueSubModalityNumbersList[0]}
            onChange={(e, data) => {
              console.log(e, data);
              handleListNumberChange(data.key);
            }}
            styles={dropdownStyles}
            defaultSelectedKey={selectedListNumber}
          />
        </div>
      ),
    },
    roles[0] === USERTYPES.ADMIN && {
      key: "2",
      button: (
        <div
          className="add-button-list-view"
          onClick={() => {
            setIsSubModalitySaved(false);
            setModalOpen(true);
          }}
        >
          <PrimaryButton
            text={t("button.add-sub-modality")}
            className={
              "common-default-active-button list-view-top-buttons-styles"
            }
          />
        </div>
      ),
    },
  ];

  const hideAddSubModalityModal = () => {
    setModalOpen(false);
  };

  const hideEditSubModalityModal = () => {
    setIsEditModalOpen(false);
  };

  let PrimaryButtonList = [
    {
      title: t("button.save"),
      onclick: saveSubModality,
    },
  ];
  let DefaultButtonList = [
    {
      title: isSubModalitySaved ? t("button.close") : t("button.cancel"),
      onclick: hideAddSubModalityModal,
    },
  ];

  let EditPrimaryButtonList = [
    {
      title: t("button.save"),
      onclick: editSubModality,
    },
  ];
  let EditDefaultButtonList = [
    {
      title: isSubModalityEdited ? t("button.close") : t("button.cancel"),
      onclick: hideEditSubModalityModal,
    },
  ];

  const modalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        showPatientDetails={false}
        heading={
          isSubModalitySaved
            ? t("confirm-message.alert")
            : t("sub-modality.add")
        }
        handleCancel={hideAddSubModalityModal}
      />
    ),
    body: (
      <NewSubModality
        selectedListNumber={selectedListNumber}
        modalityList={modalityList}
        serviceCode={serviceCode}
        setServiceCode={setServiceCode}
        serviceName={serviceName}
        setServiceName={setServiceName}
        expirationTime={expirationTime}
        setExpirationTime={setExpirationTime}
        modalityId={modalityId}
        setModalityId={setModalityId}
        modalityIdErrorMsg={modalityIdErrorMsg}
        setModalityIdErrorMsg={setModalityIdErrorMsg}
        serviceNameErrorMsg={serviceNameErrorMsg}
        setServiceNameErrorMsg={setServiceNameErrorMsg}
        expirationTimeErrorMsg={expirationTimeErrorMsg}
        setExpirationTimeErrorMsg={setExpirationTimeErrorMsg}
        serviceCodeErrorMsg={serviceCodeErrorMsg}
        setServiceCodeErrorMsg={setServiceCodeErrorMsg}
      />
    ),
    footer: (
      <ModalFooter
        PrimaryButtonList={!isSubModalitySaved ? PrimaryButtonList : null}
        DefaultButtonList={DefaultButtonList}
      />
    ),
    width: "500px",
  };

  const editModalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        showPatientDetails={false}
        heading={
          isSubModalityEdited
            ? t("confirm-message.alert")
            : t("sub-modality.edit")
        }
        handleCancel={hideEditSubModalityModal}
      />
    ),
    body: (
      <EditSubModality
        selectedListNumber={selectedListNumber}
        editServiceName={editServiceName}
        setEditServiceName={setEditServiceName}
        editExpirationTime={editExpirationTime}
        setEditExpirationTime={setEditExpirationTime}
        editServiceCode={editServiceCode}
        setEditServiceCode={setEditServiceCode}
        editExpirationTimeErrorMsg={editExpirationTimeErrorMsg}
        setEditExpirationTimeErrorMsg={setEditExpirationTimeErrorMsg}
        editServiceNameErrorMsg={editServiceNameErrorMsg}
        setEditServiceNameErrorMsg={setEditServiceNameErrorMsg}
        serviceCode={serviceCode}
        serviceName={serviceName}
        setServiceName={setServiceName}
        serviceNameErrorMsg={serviceNameErrorMsg}
        setServiceNameErrorMsg={setServiceNameErrorMsg}
        serviceCodeErrorMsg={serviceCodeErrorMsg}
        setServiceCodeErrorMsg={setServiceCodeErrorMsg}
      />
    ),
    footer: (
      <ModalFooter
        PrimaryButtonList={!isSubModalityEdited ? EditPrimaryButtonList : null}
        DefaultButtonList={EditDefaultButtonList}
      />
    ),
    width: "500px",
  };

  const handleApplyClick = (filterValue) => {
    if (filterValue != undefined) filterValue = filterValue.trim();
    setPagination(() => {
      const newItem = { ...paginationObj };
      newItem.pageIndex = 0;
      return newItem;
    });
    setTimeout(() => {
      setFilterObj(() => {
        const newItem = { ...filterObj };
        newItem.filterInput = filterValue;
        newItem.filterUpdate = newItem.filterUpdate + 1;
        return newItem;
      });
    }, 100);
  };

  return (
    <div className="main-container-body">
      {isModalOpen && !isEditModalOpen && (
        <ModalMain modalDetails={modalDetails} showModal={isModalOpen} />
      )}

      {!isModalOpen && isEditModalOpen && (
        <ModalMain
          modalDetails={editModalDetails}
          showModal={isEditModalOpen}
        />
      )}

      <ListViewV3
        buttonsTopBar={buttonsTopBar}
        sortDropdownOptions={options}
        fetchData={fetchSubModalityList}
        showSideBySide={false}
        columns={columns}
        handleUserClick={handleUserClick}
        filterObj={filterObj}
        setFilterObj={setFilterObj}
        sortObj={sortObj}
        setSortObj={setSortObj}
        setPagination={setPagination}
        handleApplyClick={handleApplyClick}
        paginationObj={paginationObj}
        unqiueKey={"SubModality"}
        placeholder={t("placeholder.service-code")}
        pointer={false}
        heading={t("navbar.sub-modalities")}
      />
    </div>
  );
};

export default SubModality;
